import axios from "axios";
import {
  getAccessToken,
  refreshJWT,
  removeAccessToken,
} from "../utils/jwtUtil.js";

// Axios 인스턴스 생성
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_HOST || "http://localhost:8080",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // 쿠키 포함
});

// 요청 인터셉터
apiClient.interceptors.request.use(
  (config) => {
    // JWT 유틸리티에서 accessToken 가져오기
    const accessToken = getAccessToken();

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // 401 에러이고 아직 재시도하지 않은 경우
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {


        // JWT 유틸리티를 사용하여 토큰 갱신
        const newAccessToken = await refreshJWT();

        if (newAccessToken) {


          // 새 토큰으로 원래 요청 재시도
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return apiClient(originalRequest);
        } else {
          throw new Error("새 토큰을 받지 못했습니다.");
        }
      } catch (refreshError) {


        // 토큰 갱신 실패 시 토큰 제거 및 로그인 페이지로 리다이렉트
        removeAccessToken();

        // 현재 페이지를 returnUri로 저장하고 로그인 페이지로 이동
        const currentPath = window.location.pathname + window.location.search;
        const loginUrl = `/login?returnUri=${encodeURIComponent(currentPath)}`;

        // SPA 라우터가 있는 경우 pushState 사용, 없으면 location.href 사용
        if (window.history && window.history.pushState) {
          window.history.pushState(null, "", loginUrl);

          // React Router가 변경을 감지하도록 popstate 이벤트 발생
          const popStateEvent = new PopStateEvent("popstate", { state: null });
          window.dispatchEvent(popStateEvent);
        } else {
          window.location.href = loginUrl;
        }

        return Promise.reject(refreshError);
      }
    }

    // 다른 에러는 그대로 전달
    return Promise.reject(error);
  }
);

export default apiClient;
